export const imgSources = [
  "local_file_system",
  "url",
  "webcam",

  "box",
  "dropbox",
  "googledrive",
  "onedrive",
  "onedriveforbusiness",
  "unsplash",

  "facebook",
  "instagram",
];

export const AllowedImageExtension = [".jpeg", ".jpg", ".png", ".gif", ".bmp"];
export const VideoExtensions = [
  ".3g2",
  ".3gp",
  ".aaf",
  ".asf",
  ".avchd",
  ".avi",
  ".drc",
  ".flv",
  ".m2v",
  ".m4p",
  ".m4v",
  ".mkv",
  ".mng",
  ".mov",
  ".mp2",
  ".mp4",
  ".mpe",
  ".mpeg",
  ".mpg",
  ".mpv",
  ".mxf",
  ".nsv",
  ".ogg",
  ".ogv",
  ".ogm",
  ".qt",
  ".rm",
  ".rmvb",
  ".roq",
  ".srt",
  ".svi",
  ".vob",
  ".webm",
  ".wmv",
  ".yuv",
];
